import React from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'
import LoginPage from '../pages/LoginPage'
import SignupPage from '../pages/SignupPage'
import ProtectedRoute from './ProtectedRoute'
import PublicRoute from './PublicRoute'
import { calculatorRoutes } from './index'
import DashboardPage from '../pages/DashboardPage'
import SubscribeSuccesPage from '../pages/SubscribeSuccesPage'
import UnavailablePage from '../pages/UnavailablePage'
import SubUserConfirmationPage from '../pages/SubUserConfirmationPage'
import CalculatorPage from '../pages/CalculatorPage'
import PenalitatePage from '../pages/PenalitatePage'
import DobandaPage from '../pages/DobandaPage'
import InflatiePage from '../pages/InflatiePage'
import ImputatiaPage from '../pages/ImputatiaPage'
import ZilePage from '../pages/ZilePage'
import DMSPage from '../pages/DMSPage'
import DashboardSection from '../components/DMSSections/DashboardSection'
import ContractsSection from '../components/DMSSections/ContractsSection'
import ClaimsSection from '../components/DMSSections/ClaimsSection'
import ReportsSection from '../components/DMSSections/ReportsSection'
import SettingsSection from '../components/DMSSections/SettingsSection'
import ContractDetailsPage from '../pages/ContractDetailsPage'
import DebtorDetailsPage from '../pages/DebtorDetailsPage'
import DebtorsSection from '../components/DMSSections/DebtorsSection'
const isTemporarilyUnavailable = false;
export default function AppRouter() {
  return (
<Routes>
      {isTemporarilyUnavailable ? ( // Check the flag for temporary unavailability
        <Route path="*" element={<UnavailablePage />} /> // Redirect all routes to UnavailablePage
      ) : (
        <>
          <Route
            path="/login"
            element={
              <PublicRoute>
                <LoginPage />
              </PublicRoute>
            }
          />
          <Route
            path="/register"
            element={
              <PublicRoute>
                <SignupPage />
              </PublicRoute>
            }
          />
          <Route
            path="/dashboard"   

            element={
              <ProtectedRoute>
                <DashboardPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/subscribe-succes"
            element={
              <ProtectedRoute>
                <SubscribeSuccesPage />
              </ProtectedRoute>
            }
          />
          <Route
            path = "/subaccount-confirmation"
            element={
              <ProtectedRoute>
                <SubUserConfirmationPage/>
              </ProtectedRoute>
            }
            
            />

            <Route
            path="/dms"
            element={
              <ProtectedRoute>
                <DMSPage />
                </ProtectedRoute>
            }
          >
              <Route index element={<Navigate to="dashboard" replace />} />
              <Route path="dashboard" element={<DashboardSection />} />
              <Route path="debtors" element={<DebtorsSection />} />
              <Route path="contracts" element={<ContractsSection />} />
              <Route path="contracts/:id" element={<ContractDetailsPage />} />
              <Route path="debtors/:id" element={<DebtorDetailsPage />} /> 
              <Route path="claims" element={<ClaimsSection />} />
              <Route path="reports" element={<ReportsSection />} />
              <Route path="settings" element={<SettingsSection />} />
            </Route>
{calculatorRoutes.map((route) => (
  <Route path={route.path} element={<route.component />} key={route.path} />
))}
          <Route path="*" element={<Navigate to="/penalitate" replace />} />
        </>
      )}
    </Routes>
  )
}
